import { defineComponent as _defineComponent } from 'vue'
import { cheackQuery, ToBack } from "@/uitls/native";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { serverConfigPiniaState } from "@/store/serverConfig";

export default /*#__PURE__*/_defineComponent({
  name: 'integralrule',
  setup(__props, { expose }) {
  expose();

const userStore = usePiniaState();
const ConfigpiniaStore = serverConfigPiniaState();

const { is_lb } = storeToRefs(ConfigpiniaStore);

const { t } = useI18n()
const route = useRoute();
const router = useRouter();

onMounted(()=>{
  cheackQuery(route)
})

const __returned__ = { userStore, ConfigpiniaStore, is_lb, t, route, router, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})